import {BaseCommand} from './base.command';
import {OverlayElementMoveSnapshot} from '../interfaces/command.interface';
import {OverlayElementApiService} from '../../../api/services/overlay-element.service';
import {OverlayElementManagerService} from '../../overlay-element-manager.service';
import {catchError, firstValueFrom, of} from 'rxjs';

export class MoveOverlayElementCommand extends BaseCommand<OverlayElementMoveSnapshot> {
  constructor(
    private overlayService: OverlayElementApiService,
    private overlayManager: OverlayElementManagerService,
    snapshot: OverlayElementMoveSnapshot
  ) {
    super(
      'move-overlay-element',
      'Overlay Position Change',
      {
        before: snapshot,
        after: snapshot
      },
      {object: 'Overlay', verb: 'Change', part: 'Position'}
    );
  }

  async execute(): Promise<void> {
    const {elementId, after} = this.snapshot.after;
    const element = this.overlayManager.getElements().find(e => e.id === elementId);
    if (element) {
      element.x = after.x;
      element.y = after.y;
      this.overlayManager.updateElement(element);
    }

    await firstValueFrom(
      this.overlayService.updatePosition(elementId, after.x, after.y).pipe(
        catchError(() => of(null))
      )
    );
  }

  async undo(): Promise<void> {
    const {elementId, before} = this.snapshot.before;
    const element = this.overlayManager.getElements().find(e => e.id === elementId);
    if (element) {
      element.x = before.x;
      element.y = before.y;
      this.overlayManager.updateElement(element);
    }

    await firstValueFrom(
      this.overlayService.updatePosition(elementId, before.x, before.y).pipe(
        catchError(() => of(null))
      )
    );
  }
}
